import { bookmarksActions } from '@redux/slices/bookmarks';
import { getAppDispatch } from '@utilities/dispatch.util';

const bookmarksJsonManipulationJson = ({ data }) => {
  const { items = [] } = data;
  return (
    items?.map((x) => {
      return { ...x, sync: true };
    }) || []
  );
};

const bookmarksDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(
    bookmarksActions.setBookmarks({
      bookmarks: data
    })
  );
};

export { bookmarksJsonManipulationJson, bookmarksDispatcher };
